import { FuneralPlanLeadAttributes, LeadAttributes } from 'lib/models/lead'
import { PRODUCTS } from 'utils/enums'

export const isFuneralPlanLead = (
  attributes: LeadAttributes
): attributes is FuneralPlanLeadAttributes => {
  return attributes.product === PRODUCTS.FUNERAL_PLAN
}
